import * as React from "react";
import { Stack } from "@mui/material";
import { StatusCard } from "@/components/dashboard/StatusCard";
import { MetricCard } from "@/components/dashboard/MetricCard";
import { EnvironmentCard } from "./EnvironmentCard";

interface SettingsCardProps {
  theme: string;
  environment: string | null | undefined;
  applicationVersion: string | null | undefined;
}

/**
 * Presentation-only summary of read-only application settings. No editing
 * control exists anywhere in this component - it never persists or
 * modifies anything, per the sprint's STOP CONDITION.
 */
export function SettingsCard({ theme, environment, applicationVersion }: SettingsCardProps): React.JSX.Element {
  return (
    <StatusCard title="Application Settings">
      <Stack spacing={1.5}>
        <MetricCard label="Theme" value={theme} />
        <EnvironmentCard environment={environment} />
        <MetricCard label="Application Version" value={applicationVersion} />
      </Stack>
    </StatusCard>
  );
}
